import React from "react";
import "./App.css";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  useLocation,
  Navigate,
  Link,
} from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { ToastContainer } from "react-toastify";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import Header from "./Components/Header/Header";
import Footer from "./Components/Footer/Footer";

// Page Components
import HomePage from "./Components/homepage";
import Programs from "./Components/Program";
import BookCard from "./Components/Book";
import EJournals from "./Components/E-Journals";
import EMagazines from "./Components/E-Magazines";
import MembershipPage from "./Components/membership";
import MembershipForm from "./Components/membershipForm";
import BlogPage from "./Components/blog";
import BlogDetail from "./Components/BlogDetail";
import Research from "./Components/Research";
import Counselling from "./Components/Counselling";
import ContactPage from "./Components/Contact/Contact";
import DonatePage from "./Components/DonatePage";
import Admin from "./Components/Admin";
import NavveerBooks from "./Components/NavveerBooks";
import AdminLogin from "./Components/adminLogin";

// Reusable animated wrapper for pages
const MotionPage = ({ children }) => (
  <motion.div
    initial={{ opacity: 0, y: 40 }}
    animate={{ opacity: 1, y: 0 }}
    exit={{ opacity: 0, y: -20 }}
    transition={{ duration: 0.4 }}
  >
    {children}
  </motion.div>
);

// Simple admin protected route
const AdminRoute = () => {
  const isAuthed = localStorage.getItem("navveer_admin_auth") === "true";

  if (!isAuthed) {
    return <Navigate to="/admin-login" replace />;
  }

  return (
    <MotionPage>
      <Admin />
    </MotionPage>
  );
};

// Animation wrapper
const AnimatedRoutes = () => {
  const location = useLocation();

  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        <Route
          path="/"
          element={
            <motion.div
              initial={{ opacity: 0, y: 40 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -30 }}
              transition={{ duration: 0.4 }}
            >
              <HomePage />
            </motion.div>
          }
        />

        <Route
          path="/programs"
          element={
            <MotionPage>
              <Programs />
            </MotionPage>
          }
        />
        <Route
          path="/membership"
          element={
            <MotionPage>
              <MembershipPage />
            </MotionPage>
          }
        />
        <Route
          path="/membership/form"
          element={
            <MotionPage>
              <MembershipForm />
            </MotionPage>
          }
        />

        {/* Blog list & detail */}
        <Route
          path="/blog"
          element={
            <MotionPage>
              <BlogPage />
            </MotionPage>
          }
        />
        <Route
          path="/blogs/:id"
          element={
            <MotionPage>
              <BlogDetail />
            </MotionPage>
          }
        />

        {/* Books / Library */}
        <Route path="/NavveerBooks" element={<NavveerBooks />} />
        <Route
          path="/library"
          element={
            <MotionPage>
              <BookCard />
            </MotionPage>
          }
        />
        <Route
          path="/library/books"
          element={
            <MotionPage>
              <NavveerBooks />
            </MotionPage>
          }
        />
        <Route
          path="/library/ejournals"
          element={
            <MotionPage>
              <EJournals />
            </MotionPage>
          }
        />
        <Route
          path="/library/emagazines"
          element={
            <MotionPage>
              <EMagazines />
            </MotionPage>
          }
        />

        {/* Research, counselling, contact, donate */}
        <Route
          path="/research"
          element={
            <MotionPage>
              <Research />
            </MotionPage>
          }
        />

        {/* Protected Admin route */}
        <Route path="/admin" element={<AdminRoute />} />

        {/* Admin login route */}
        <Route
          path="/admin-login"
          element={
            <MotionPage>
              <AdminLogin />
            </MotionPage>
          }
        />

        <Route
          path="/counselling"
          element={
            <MotionPage>
              <Counselling />
            </MotionPage>
          }
        />
        <Route
          path="/contact"
          element={
            <MotionPage>
              <ContactPage />
            </MotionPage>
          }
        />
        <Route
          path="/donate"
          element={
            <MotionPage>
              <DonatePage />
            </MotionPage>
          }
        />
      </Routes>
    </AnimatePresence>
  );
};

const App = () => {
  return (
    <Router>
      <ToastContainer position="top-right" autoClose={3000} />
      <div className="app-container">
        <Header />
        <main className="main-content">
          <AnimatedRoutes />
        </main>
        <Footer />
      </div>

      <Link to="/donate" className="donate-float-button" title="Support Us">
        <i className="bi bi-heart-fill"></i>
      </Link>
    </Router>
  );
};

export default App;
